var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgQuestionMarkIcon = function SvgQuestionMarkIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8573 17.6825C18.3134 16.386 19.2136 15.2927 20.3986 14.5963C21.5835 13.8998 22.9767 13.6453 24.3314 13.8776C25.686 14.11 26.9148 14.8143 27.7999 15.8658C28.6851 16.9173 29.1695 18.2481 29.1675 19.6225C29.1675 23.5025 23.3475 25.4425 23.3475 25.4425M23.5027 33.2025H23.5221M42.9027 23.5025C42.9027 34.2169 34.217 42.9025 23.5027 42.9025C12.7883 42.9025 4.10266 34.2169 4.10266 23.5025C4.10266 12.7882 12.7883 4.10254 23.5027 4.10254C34.217 4.10254 42.9027 12.7882 42.9027 23.5025Z",
    stroke: "currentColor",
    strokeWidth: 3.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionMarkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "question-mark-icon.fdf6017df67f13d7f1d408fba0b8a6fb.svg";